/// <amd-module name="VSS/Features/Frame/ContributedContentComponent" />
import * as React from "react";

import { css } from "VSSUI/Util";
import { WrappedComponent } from "VSS/Platform/Layout";

export interface IContributedContentComponentProps {
    contributionId: string;
    contribution: {
        uri?: string;
        componentType?: string;
        componentProperties?: { [propertyName: string]: any };
        dependencies?: string[];
        [propertyName: string]: any;
    };
    className?: string;
    dependencies?: string[];
    componentProperties?: { [propertyName: string]: any };
}

export function ContributedContentComponent(props: IContributedContentComponentProps): JSX.Element | null {
    const sharedProps = {
        ...props.componentProperties,
        ...props.contribution.componentProperties,
        className: css(
            props.className,
            props.componentProperties && props.componentProperties.className,
            props.contribution.componentProperties && props.contribution.componentProperties.className
        )
    };

    const dependencies = [...(props.dependencies || []), ...(props.contribution.dependencies || [])];

    if (props.contribution.uri) {
        return (
            <WrappedComponent
                dependencies={dependencies.concat(["ms.vss-web.ext-content"])}
                wrappedType="ExternalContent"
                wrappedProps={{
                    ...sharedProps,
                    contributionId: props.contributionId
                }}
            />
        );
    } else if (props.contribution.componentType) {
        return <WrappedComponent dependencies={dependencies} wrappedType={props.contribution.componentType} wrappedProps={sharedProps} />;
    } else {
        return null;
    }
}
